import { useCallback, useEffect, useState } from 'react';
import { AdminMessage, AppType } from '~/models/admin';
import adminService from '~/services/admin-service';
import {
    SET_ADMIN_MESSAGES_LOADING,
    SET_ADMIN_MESSAGES_ERROR,
    SET_ADMIN_MESSAGES,
} from '~/store/actions';
import { useStateValue } from '~/store/store';

const useCheckMaintenance = ({ app }: { app: AppType }) => {
    const { state, dispatch } = useStateValue();
    const [message, setMessage] = useState<AdminMessage | undefined>(undefined);

    const setLoading = (loading: boolean) => {
        dispatch({
            type: SET_ADMIN_MESSAGES_LOADING,
            payload: {
                admin: {
                    isLoading: loading,
                },
            },
        });
    };

    const setError = (error: string | undefined) => {
        dispatch({
            type: SET_ADMIN_MESSAGES_ERROR,
            payload: {
                admin: {
                    error,
                },
            },
        });
    };

    const getMaintenanceMessages = useCallback(async () => {
        try {
            const response = await adminService.getAdminMessages();
            dispatch({
                type: SET_ADMIN_MESSAGES,
                payload: {
                    admin: {
                        messages: Array.isArray(response?.data) ? response.data : [],
                    },
                },
            });

            if (response?.data) {
                const responseMsg = response.data.find(msg => msg.app === app);
                if (responseMsg?.app !== message?.app) {
                    setMessage(responseMsg);
                }
            }
            setLoading(false);
        } catch (err) {
            setError('Admin API error');
            setLoading(false);
        }
    }, [dispatch, app]);

    useEffect(() => {
        if (
            !state?.admin?.isLoading &&
            !state?.admin?.error &&
            (!Array.isArray(state?.admin?.messages) || !state?.admin?.messages?.length)
        ) {
            getMaintenanceMessages();
        } else if (
            Array.isArray(state?.admin?.messages) &&
            state?.admin?.messages?.length &&
            !message
        ) {
            const msg = state?.admin?.messages.find(msg => msg.app === app);
            setMessage(msg);
        }
    }, [dispatch, app]);

    return {
        message,
        loading: !!state?.admin?.isLoading,
        error: state?.admin?.error,
    };
};

export default useCheckMaintenance;
